import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "row mt-md-5 mt-2 gy-5"
};
const _hoisted_2 = {
  class: "col-lg-6 col-md-6 col-sm-12"
};
const _hoisted_3 = {
  class: "image-container-right"
};
const _hoisted_4 = {
  ref: "videoAssess",
  class: "myVideoClass",
  style: {
    "object-fit": "cover"
  },
  loop: "",
  autoplay: "",
  muted: "",
  playsinline: "",
  preload: "metadata",
  "aria-label": "Assess"
};
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock(_Fragment, null, [_cache[2] || (_cache[2] = _createElementVNode("div", {
    class: "row mt-md-5 mt-2 gy-4"
  }, [_createElementVNode("div", {
    class: "col-lg-6 col-md-6 col-sm-12"
  }, [_createElementVNode("div", {
    class: "content_container"
  }, [_createElementVNode("h2", null, "1. Assess"), _createElementVNode("p", null, " Share your trip details with ITIRA, your AI guide. It'll analyze your travel plans and align them with custom safety packages, making prep work a breeze. ")])]), _createElementVNode("div", {
    class: "col-lg-6 col-md-6 col-sm-12"
  }, [_createElementVNode("div", {
    class: "image-container-right"
  }, [_createElementVNode("video", {
    class: "myVideoClass",
    style: {
      "object-fit": "cover"
    },
    loop: "",
    autoplay: "",
    muted: "",
    playsinline: "",
    preload: "metadata",
    "aria-label": "Assess"
  }, [_createElementVNode("source", {
    src: "https://res.cloudinary.com/dhw4x5rfc/video/upload/v1732560545/itira_rzpdjr.mp4",
    type: "video/mp4"
  }), _createTextVNode(" Your browser does not support the video tag. ")])])])], -1)), _cache[3] || (_cache[3] = _createElementVNode("div", {
    class: "row mt-md-5 mt-2 gy-5",
    id: "reorder"
  }, [_createElementVNode("div", {
    class: "col-lg-6 col-md-6 col-sm-12",
    id: "order-1"
  }, [_createElementVNode("div", {
    class: "image-container-left"
  }, [_createElementVNode("video", {
    class: "myVideoClass",
    style: {
      "object-fit": "cover"
    },
    loop: "",
    autoplay: "",
    muted: "",
    playsinline: "",
    preload: "metadata",
    "aria-label": "Choose"
  }, [_createElementVNode("source", {
    src: "https://res.cloudinary.com/dhw4x5rfc/video/upload/v1732560566/choose_swd1yi.mp4",
    type: "video/mp4"
  }), _createTextVNode(" Your browser does not support the video tag. ")])])]), _createElementVNode("div", {
    class: "col-lg-6 col-md-6 col-sm-12",
    id: "order-2"
  }, [_createElementVNode("div", {
    class: "content_container"
  }, [_createElementVNode("h2", null, "2. Choose"), _createElementVNode("p", null, " Choose from personalized travel insurance options. Whether it's solo adventures or family trips, select the coverage that fits, ensuring you stay focused on the experiences ahead. ")])])], -1)), _cache[4] || (_cache[4] = _createElementVNode("div", {
    class: "row mt-md-5 mt-2 gy-5",
    id: "mob-reorder"
  }, [_createElementVNode("div", {
    class: "col-lg-6 col-md-6 col-sm-12"
  }, [_createElementVNode("div", {
    class: "content_container"
  }, [_createElementVNode("h2", null, "2. Choose"), _createElementVNode("p", null, " Choose from personalized travel insurance options. Whether it's solo adventures or family trips, select the coverage that fits, ensuring you stay focused on the experiences ahead. ")])]), _createElementVNode("div", {
    class: "col-lg-6 col-md-6 col-sm-12"
  }, [_createElementVNode("div", {
    class: "image-container-left img-section"
  }, [_createElementVNode("video", {
    class: "myVideoClass",
    style: {
      "object-fit": "cover"
    },
    loop: "",
    autoplay: "",
    muted: "",
    playsinline: "",
    preload: "metadata",
    "aria-label": "Choose"
  }, [_createElementVNode("source", {
    src: "https://res.cloudinary.com/dhw4x5rfc/video/upload/v1732560566/choose_swd1yi.mp4",
    type: "video/mp4"
  }), _createTextVNode(" Your browser does not support the video tag. ")])])])], -1)), _createElementVNode("div", _hoisted_1, [_cache[1] || (_cache[1] = _createElementVNode("div", {
    class: "col-lg-6 col-md-6 col-sm-12"
  }, [_createElementVNode("div", {
    class: "content_container"
  }, [_createElementVNode("h2", null, "3. Protect"), _createElementVNode("p", null, " With our app, you're never alone. Get real-time assistance for any travel hiccup, from medical emergencies to unexpected delays, keeping your journey smooth and enjoyable. ")])], -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("video", _hoisted_4, _cache[0] || (_cache[0] = [_createElementVNode("source", {
    src: "https://res.cloudinary.com/dhw4x5rfc/video/upload/v1732560588/protect_luzetk.mp4",
    type: "video/mp4"
  }, null, -1), _createTextVNode(" Your browser does not support the video tag. ")]), 512)])])])], 64);
}